/**
 * Утилита для проверки токена в браузере
 */

/**
 * Проверяет и исправляет токен в localStorage
 */
export function checkAndFixToken() {
    const currentToken = localStorage.getItem('token');
    
    // Проверяем, правильный ли токен
    if (currentToken === 'demo_token') {
        localStorage.setItem('token', 'demo-token');
        return 'demo-token';
    }
    
    if (currentToken === 'demo-token') {
        return currentToken;
    }
    
    // НЕ устанавливаем токен автоматически - пользователь должен войти
    if (!currentToken) {
        return null;
    }
    
    return currentToken;
}

/**
 * Проверяет токен при загрузке страницы
 */
export function initTokenCheck() {
    if (typeof window !== 'undefined') {
        checkAndFixToken();
    }
}


